import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

const apiKey = process.env.REACT_APP_BUGSNAG_API_KEY
const bugsnagDisabled = process.env.REACT_APP_DISABLE_BUGSNAG === '1'

let ErrorBoundary

if (apiKey && !bugsnagDisabled) {
    Bugsnag.start({
        apiKey,
        plugins: [new BugsnagPluginReact()],
        autoDetectErrors: (process.env.REACT_APP_ENVIRONMENT || 1) ? false : true,
        releaseStage: process.env.REACT_APP_ENVIRONMENT || 'development',
        appVersion: process.env.REACT_APP_VERSION,
    })
    ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)
} else {
    ErrorBoundary = function BugsnagPassthrough({ children }) {
        return children
    }
}

export default ErrorBoundary
